export const SharePlatformDisplayConstants = {
  nextdoor: {
    platformName: 'nextdoor',
    buttonIcon: 'nextdoor',
    accentColor: 'social-nextdoor',
  },
  facebook: {
    platformName: 'facebook',
    buttonIcon: 'facebook',
    accentColor: 'social-facebook',
  },
  twitter: {
    platformName: 'twitter',
    buttonIcon: 'twitter',
    accentColor: 'social-twitter',
  },
  google: {
    platformName: 'google',
    buttonIcon: 'google',
    accentColor: 'social-google',
  },
  sms: {
    platformName: 'sms',
    buttonIcon: 'mobile',
    accentColor: 'tertiary',
  },
  link: {
    platformName: 'link',
    buttonIcon: 'copy',
    accentColor: 'primary',
  },
  email: {
    platformName: 'email',
    buttonIcon: 'email',
    accentColor: 'tertiary',
  },
};

export const ShareVariationConstants = {
  // used for ShareView
  web: {
    default: {
      ...SharePlatformDisplayConstants.nextdoor,
    },
    email_share_v1: {
      ...SharePlatformDisplayConstants.email,
    },
    facebook_share_v1: {
      ...SharePlatformDisplayConstants.facebook,
    },
    google_share_v1: {
      ...SharePlatformDisplayConstants.google,
    },
    nextdoor_share_v1: {
      ...SharePlatformDisplayConstants.nextdoor,
    },
    // keep while growth still has nextdoor-v2 tests
    nextdoor_share_v2: {
      ...SharePlatformDisplayConstants.nextdoor,
    },
    twitter_share_v1: {
      ...SharePlatformDisplayConstants.twitter,
    },
  },

  // used for ServicesView ShareWidget
  web_services: {
    default: {
      ...SharePlatformDisplayConstants.nextdoor,
    },
    email_share_v1: {
      ...SharePlatformDisplayConstants.email,
    },
    facebook_share_v1: {
      ...SharePlatformDisplayConstants.facebook,
    },
    google_share_v1: {
      ...SharePlatformDisplayConstants.google,
    },
    nextdoor_share_v1: {
      ...SharePlatformDisplayConstants.nextdoor,
    },
    // keep while growth still has nextdoor-v2 tests
    nextdoor_share_v2: {
      ...SharePlatformDisplayConstants.nextdoor,
    },
    twitter_share_v1: {
      ...SharePlatformDisplayConstants.twitter,
    },
  },
};
